import gql from 'graphql-tag';

const ADD_CAMPAIGN = gql`
  mutation addCampaign($campaignModifiers: CampaignModifiers!, $file: Upload) {
    addCampaign(campaignModifiers: $campaignModifiers, file: $file) {
      data {
        id
        payer_ids
        status
        name
        description
        file_name
        file_upload_message
        file_upload_status
        priority
        pharmacy_ids
        plan_ids
        special_notes
        assigned_enrollers
      }
    }
  }
`;

export default ADD_CAMPAIGN;
